import { getUriParams } from '../../../helpers';
import {
  CORE, gateway,
} from '../../api';

export function findClienteByNumProcesso(numProcesso) {
  return gateway.get(`${CORE}/manutencao/cliente-atual/${numProcesso}`);
}

// Contrato assumido (endpoint ainda não confirmado com o backend): "código do cliente novo"
// é tratado como equivalente ao idCliente usado por findSimpleCliente (ver plano AW2-359).
export function updateClienteDoProcesso(numProcesso, codigoClienteNovo, recalcularValor, justificativa) {
  const uri = getUriParams({ recalcularValor: recalcularValor === 'S', justificativa });
  return gateway.put(`${CORE}/manutencao/atualizar-cliente/${numProcesso}/${codigoClienteNovo}?${uri}`);
}

// Contrato assumido (endpoint ainda não existe no backend — a implementar posteriormente, ver
// plano AW2-518 Etapa 1): resposta esperada { idProcesso, idUsuarioComercial, nomeComercial }.
export function findComercialAtualByNumProcesso(numProcesso) {
  return gateway.get(`${CORE}/manutencao/comercial-atual/${numProcesso}`);
}

// Contrato assumido (endpoint ainda não existe no backend — a implementar posteriormente, ver
// plano AW2-518 Etapa 1). "Código do novo usuário comercial" é tratado como equivalente ao
// idUsuario usado por getUsuarioCompletoPeloId (usuario.services.js), mesma decisão já tomada
// para cliente em updateClienteDoProcesso/AW2-359. O backend deve revalidar, no momento da
// escrita: a permissão 2601 de quem executa a ação, a existência do processo, e que o usuário
// comercial informado está ativo e possui perfil comercial — nunca confiar apenas na validação
// client-side (feita nas etapas de UI deste plano, reaproveitando getUsuarioCompletoPeloId e
// buscarIdTipoUsuarioComercial, ambos já existentes em usuario.services.js).
export function updateComercialDoProcesso(numProcesso, codigoComercialNovo, justificativa) {
  const uri = getUriParams({ justificativa });
  return gateway.put(`${CORE}/manutencao/atualizar-comercial/${numProcesso}/${codigoComercialNovo}?${uri}`);
}

// Contrato assumido (endpoint ainda não existe no backend — a implementar posteriormente, ver
// plano AW2-519 Etapa 1): resposta esperada { idProcesso, porcentagemComissao, porcentagemPagtoDireto }.
export function findPercentuaisAtuaisByNumProcesso(numProcesso) {
  return gateway.get(`${CORE}/manutencao/percentuais-atuais/${numProcesso}`);
}

// Contrato assumido (endpoint ainda não existe no backend — a implementar posteriormente, ver
// plano AW2-519 Etapa 1). Os 2 percentuais são sempre enviados com o valor final desejado, mesmo
// quando só um dos dois foi alterado pelo usuário (o outro é reenviado com o valor atual
// inalterado) — decisão deste plano para manter o contrato simples (estado final, não um diff
// parcial). O backend deve revalidar, no momento da escrita: a permissão 2601 de quem executa a
// ação, a existência do processo, a ausência de lançamento na Ficha Financeira (mesma verificação
// já usada em updateClienteDoProcesso/AW2-359) e que os 2 percentuais estão entre 0 e 100 —
// nunca confiar apenas na validação client-side. Percentuais são enviados com ponto decimal
// (ex.: 12.5), não localizado (sem vírgula).
export function updatePercentuaisDoProcesso(
  numProcesso,
  porcentagemComissao,
  porcentagemPagtoDireto,
  justificativa,
) {
  const uri = getUriParams({ porcentagemComissao, porcentagemPagtoDireto, justificativa });
  return gateway.put(`${CORE}/manutencao/atualizar-percentuais/${numProcesso}?${uri}`);
}

// Contrato confirmado contra a especificação real do backend (projeto SEPARADO
// abe-web-core-spring, docs/architecture/AW2-1290-retirar-controle-expiracao-processo.md, Etapa
// 6 — ControleExpiracaoAtualProcessoQuery). Resposta real: { idProcesso, idCliente, nomeCliente,
// clienteControlaExpiracao (bool, Cliente.controlarExpiracaoProcesso da AW2-365),
// prazosExpiracaoCliente (lista de faixas por valor — não consumida por esta tela, AC não exige
// exibir um prazo único resolvido), dataExpiracaoProcesso (string ISO, não consumida por esta
// tela), retiradoControleExpiracao (bool), processoBaixado (bool, derivado de
// idMotivoBaixa != null no backend) }. Note que o backend NÃO devolve "numProcesso" — a tela usa
// o valor já digitado localmente para exibição, nunca um campo da resposta.
export function findControleExpiracaoAtualByNumProcesso(numProcesso) {
  return gateway.get(`${CORE}/manutencao/controle-expiracao-atual/${numProcesso}`);
}

// Contrato confirmado (mesmo documento do GET acima, Etapa 6). A remoção do controle de
// expiração é definitiva — por decisão de produto validada com o usuário (16/10/2026), não existe
// e nunca existirá uma operação equivalente de "reincluir". O backend revalida, nesta ordem, as
// mesmas 3 condições de bloqueio já checadas no client (processo baixado, processo já retirado,
// cliente sem controle de expiração) — nunca confiar que a UI já filtrou esses casos, pois não há
// como desfazer um bypass depois. `idUsuario` é obrigatório como HEADER (não query/body) — o
// backend só usa para auditoria/log, nunca para autorização (permissão 2601 é responsabilidade do
// gateway/BFF, fora deste endpoint, mesma decisão já tomada para AW2-359/518/519).
export function retirarControleExpiracaoDoProcesso(numProcesso, justificativa, idUsuario) {
  const uri = getUriParams({ justificativa });
  return gateway.put(
    `${CORE}/manutencao/retirar-controle-expiracao/${numProcesso}?${uri}`,
    null,
    { headers: { idUsuario } },
  );
}
